"use client";

import Image from "next/image";

import { type Category } from "@coinbot/forge-api/schema";

import { ThorLogo } from "~/assets";
import CheckGradient from "~/assets/check-gradient.svg";

export type CategoryRowItemProps = {
  index: number;
  category: Category;
};

export function CategoryRowItem({ index, category }: CategoryRowItemProps) {
  return (
    <div className="flex w-full items-center space-x-2.5 p-2 duration-200 hover:bg-white/5 md:space-x-4">
      {index !== undefined && (
        <div className="w-4 text-center text-lg md:w-8 md:text-2xl">{index + 1}</div>
      )}

      <div className="!ml-1.5 flex h-10 w-10 items-center justify-center bg-dark-subtle-gradient md:!ml-3 md:h-16 md:w-16">
        {category?.icon ? (
          <Image src={category?.icon} priority alt={category?.name} className="size-5 md:size-5" />
        ) : (
          <ThorLogo className="size-5 md:size-8" />
        )}
      </div>

      <div className="flex flex-col">
        <div className="flex items-center">
          <div className="text-sm font-semibold tracking-wide md:text-lg">{category?.name}</div>

          <CheckGradient className="ml-1" />
        </div>

        <div className="flex items-center">
          <div className="flex items-center gap-2 text-xs text-white/60 md:mt-0 md:text-base">
            <div>
              {category?.totalItems
                ? Intl.NumberFormat("en-US", { notation: "standard" }).format(category?.totalItems)
                : "0"}{" "}
              items
            </div>
          </div>
        </div>
      </div>

      {/* <div className="!ml-auto flex flex-col items-end">
        <Price
          className="space-x-1.5"
          value={9999999}
          chain={Chain.THORChain}
          srcIcon={runeIconColor}
        />

        <div className="text-[#F7FAFD]/70">{formatPrice(99999, { asUSD: true })}</div>
      </div> */}
    </div>
  );
}
